import React from 'react';
import { motion } from 'framer-motion';
import { Award, Download, GraduationCap } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { getEnrolledCourses, COURSES, getUser } from '@/lib/data';

export default function Certificates() {
  const user = getUser() || { name: 'Student' };
  const enrolled = getEnrolledCourses();
  const completed = enrolled
    .filter(e => e.progress >= 100)
    .map(e => ({ ...e, course: COURSES.find(c => c.id === e.courseId) }))
    .filter(e => e.course);

  return (
    <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} className="space-y-6">
      <div>
        <h1 className="font-heading text-2xl font-bold">Certificates</h1>
        <p className="text-muted-foreground text-sm mt-1">{completed.length} certificate{completed.length !== 1 ? 's' : ''} earned</p>
      </div>

      {completed.length > 0 ? (
        <div className="space-y-6">
          {completed.map((item, i) => (
            <motion.div
              key={item.courseId}
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: i * 0.1 }}
            >
              {/* Certificate Preview */}
              <div className="bg-card rounded-xl border overflow-hidden">
                <div className="bg-gradient-to-br from-primary/10 via-background to-accent/10 p-8 sm:p-12">
                  <div className="max-w-xl mx-auto bg-card rounded-2xl border-2 border-primary/20 p-8 sm:p-10 text-center shadow-lg">
                    <div className="flex justify-center mb-4">
                      <div className="w-16 h-16 rounded-full bg-primary/10 flex items-center justify-center">
                        <GraduationCap className="w-8 h-8 text-primary" />
                      </div>
                    </div>
                    <p className="text-xs text-muted-foreground uppercase tracking-widest">Certificate of Completion</p>
                    <h2 className="font-heading text-2xl sm:text-3xl font-bold mt-4 text-primary">XceedEdge</h2>
                    <p className="text-muted-foreground text-sm mt-6">This certifies that</p>
                    <p className="font-heading text-xl font-bold mt-1">{user.name}</p>
                    <p className="text-muted-foreground text-sm mt-4">has successfully completed</p>
                    <p className="font-heading text-lg font-semibold mt-1">{item.course.title}</p>
                    <div className="flex justify-center gap-8 mt-6 pt-6 border-t">
                      <div>
                        <p className="text-xs text-muted-foreground">Date</p>
                        <p className="text-sm font-medium">{new Date().toLocaleDateString()}</p>
                      </div>
                      <div>
                        <p className="text-xs text-muted-foreground">Certificate ID</p>
                        <p className="text-sm font-medium">XE-{Math.random().toString(36).substr(2, 8).toUpperCase()}</p>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="p-4 border-t flex justify-end">
                  <Button className="gap-2">
                    <Download className="w-4 h-4" /> Download Certificate
                  </Button>
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      ) : (
        <div className="text-center py-20 bg-card rounded-xl border">
          <Award className="w-12 h-12 text-muted-foreground/30 mx-auto mb-4" />
          <h3 className="font-heading font-semibold text-lg">No certificates yet</h3>
          <p className="text-muted-foreground text-sm mt-1">Complete a course to earn your first certificate!</p>
        </div>
      )}
    </motion.div>
  );
}